import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Badge } from "antd";
import {
  StyledContainerOutlined,
  StyledUnorderedListOutlined,
  StyledTeamOutlined,
  StyledSpan,
  StyledMenu,
  StyledDatabaseOutlined,
  StyledHeatMapOutlined,
  StyledAuditOutlined,
  StyledBookOutlined,
  StyledCalendarOutlined,
  StyledExperimentOutlined,
} from "../components/MenuComponents";
//import components
import UserRolesAndRightsHOComponent from "../components/UserRolesAndRightsHOComponent/UserRolesAndRightsHOComponent";
import authorization from "../auth/authorization";
import { useAppConfig } from "../hooks/useAppConfig";

const MainMenu = ({
  userType,
  notificationCount,
}) => {
  const history = useHistory();
  let location = useLocation();
  const ENABLE_DATA_GENERATOR = useAppConfig('ENABLE_DATA_GENERATOR');
  const [selectedMenuItem, setSelectedMenuItem] = useState(["lists"]);
  const setSelectedRoute = (pathname) => {
    const seperatedPathName = pathname.split("/");
    let selectedMenuForPath = "";
    switch (seperatedPathName[1]) {
      case "physicians":
        selectedMenuForPath = "physicians";
        break;
      case "dictionary":
        selectedMenuForPath = "lists";
        break;
      case "cases":
        selectedMenuForPath = "cases";
        break;
      case "report":
        selectedMenuForPath = "report";
        break;
      case "report-charts":
        selectedMenuForPath = "charts";
        break;
      case "case-tickets":
        selectedMenuForPath = "tickets";
        break;
      case "articles":
        selectedMenuForPath="articles";
        break;
      case 'appointments':
        selectedMenuForPath='appointments';
        break;
      case 'data-generator':
        selectedMenuForPath='data-generator';
        break;
      default:
        selectedMenuForPath = "charts";
    }
    setSelectedMenuItem([`${selectedMenuForPath}`]);
  };

  useEffect(() => {
    setSelectedRoute(location.pathname);
  }, [location]);

  const getRoute = (key) => {
    switch (key) {
      case "lists":
        return {
          route: "/dictionary",
          selectedMenu: ["lists"],
        };
      case "physicians":
        return {
          route: "/physicians",
          selectedMenu: ["physicians"],
        };
      case "cases":
        return {
          route: "/cases",
          selectedMenu: ["cases"],
        };

      case "report":
        return {
          route: "/report",
          selectedMenu: ["report"],
        };

      case "charts":
        return {
          route: "/report-charts",
          selectedMenu: ["charts"],
        };
      case "tickets":
        return {
          route: "/case-tickets",
          selectedMenu: ["charts"],
        };
      case "articles":
        return{
          route:"/articles",
          selectedMenu:["articles"]
        }
      case "appointments":
        return {
          route: '/appointments',
          selectedMenu: ['appointments']
        }
      case "data-generator":
        return {
          route: '/data-generator',
          selectedMenu: ['data-generator']
        }
      default:
        return {
          route: "/report-charts",
          selectedMenu: ["charts"],
        };
    }
  };

  const onMenuItemClick = (menuItemClicked) => {
    const { key } = menuItemClicked;

    const goToRoute = getRoute(key);
    setSelectedMenuItem(goToRoute.selectedMenu);
    history.push(goToRoute.route);
  };

  const items = [
    ...(authorization.hasAccessToModule(userType, [
      "consultCompleteReport",
      "consultNoRXReport",
      "clientCasesReport",
      "physicianCaseReport",
    ]) ? [{
      key: "charts",
      label: (
        <>
          <StyledHeatMapOutlined />
          <StyledSpan>Reports</StyledSpan>
        </>
      ),
    }] : []),
    {
      key: "lists",
      label: (
        <>
          <StyledUnorderedListOutlined />
          <StyledSpan>Manage Lists</StyledSpan>
        </>
      ),
    },
    ...(authorization.hasAccessToModule(userType, [
      "getPhysicianForAdmin",
      "getPhysicianDetailsForAdmin",
    ]) ? [{
      key: "physicians",
      label: (
        <>
          <StyledTeamOutlined />
          <StyledSpan>Manage Physicians</StyledSpan>
        </>
      ),
    }] : []),
    ...(authorization.hasAccessToModule(userType, [
      "getCasesDetails",
      "updateCase",
      "caseStatusModification",
      "getCases",
    ]) ? [{
      key: "cases",
      label: (
        <>
          <StyledContainerOutlined />
          <StyledSpan>Manage Cases</StyledSpan>
        </>
      ),
    }] : []),
    ...(authorization.hasAccessToModule(userType, [
      'getCasesDetails',
      'getCases'
    ]) ? [{
      key: 'appointments',
      label: (
        <>
          <StyledCalendarOutlined />
          <StyledSpan>Manage Appointments</StyledSpan>
        </>
      ),
    }] : []),
    ...(authorization.hasAccessToModule(userType, [
      "consultCompleteReport",
      "consultNoRXReport",
      "clientCasesReport",
      "physicianCaseReport",
    ]) ? [{
      key: "report",
      label: (
        <>
          <StyledDatabaseOutlined />
          <StyledSpan>QA</StyledSpan>
        </>
      ),
    }] : []),
    ...(authorization.hasAccessToModule(userType, ["caseTicketListing"]) ? [{
      key: "tickets",
      label: (
        <>
          <StyledAuditOutlined />
          <Badge count={notificationCount}>
            <StyledSpan>Case Tickets</StyledSpan>
          </Badge>
        </>
      ),
    }] : []),
    {
      key: "articles",
      label: (
        <>
          <StyledBookOutlined />
          <StyledSpan>Articles</StyledSpan>
        </>
      ),
    },
    ...(ENABLE_DATA_GENERATOR ? [{
      key: "data-generator",
      label: (
        <>
          <StyledExperimentOutlined />
          <StyledSpan>Data Generator</StyledSpan>
        </>
      ),
    }] : []),
  ];

  return (
    <StyledMenu
      onClick={onMenuItemClick}
      defaultSelectedKeys={["lists"]}
      selectedKeys={selectedMenuItem}
      mode="inline"
      items={items}
    />
  );
};

export default UserRolesAndRightsHOComponent(MainMenu);
